import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Store } from '@ngrx/store'
import { selectProfileState } from '../account/user-profile/user-profile.state'
import { Observable, take } from 'rxjs'
import { map } from 'rxjs/operators'
import { PendingState } from '../account/account.root.state'

@Injectable({
  providedIn: 'root',
})
export class NewUserGuard {
  constructor(private router: Router, private readonly store: Store) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(selectProfileState.c4LoginState).pipe(
      take(1),
      map(actionDispatched => {
        if (actionDispatched === PendingState.failed) {
          // If action has been dispatched, allow activation
          return true
        } else {
          // Else, redirect to another url
          return this.router.parseUrl('/navigation')
        }
      }),
    )

    // canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    //   console.log(route)
    //   console.log('Help')
    //   const isFromCodeNavigation = route.data.state
    //   console.log(isFromCodeNavigation)
    //   console.log(route.queryParamMap)
    //   console.log(route.queryParams)
    //
    //   if (isFromCodeNavigation) {
    //     console.log('Enterred true')
    //     return true;
    //   } else {
    //     console.log('False')
    //     // Redirect to a default route or show an error page
    //     return this.router.createUrlTree(['/navigation'], {relativeTo: null});
    //   }
  }
}
